module.exports = __webpack_public_path__ + "img/Board_Bingo.ea2fdb69.png";